/* @flow */
import * as React from 'react';
import classnames from 'classnames/bind';

import s from './PopoutActionsMenu.styl';
const cx = classnames.bind(s);

/**
 * The three dots that when clicked expand into whatever is passed as children
 *
 * NOTE: This component does not (yet) account for window position. So if used
 * in other window areas it may expand below or to the left of the window. This
 * can be addressed if we end up needing it.
 */
export class PopoutActionsMenu extends React.Component {
  props: {
    children: $TODO,
    className?: string,
    innerClassName?: string,
    contentClassName?: string,
  };

  state = {
    isOpen: false,
  };

  open = (e: SyntheticEvent) => {
    e.stopPropagation();
    this.setState(() => ({ isOpen: true }));
  };

  close = () => this.setState(() => ({ isOpen: false }));

  render() {
    const { isOpen } = this.state;
    const { children, className, innerClassName, contentClassName } = this.props;

    return (
      <div onClick={this.close} data-cy={'popoutActionsMenu'} className={cx('PopoutActionsMenu', className, { isOpen })}>
        <div onClick={this.open} className={cx('dots', innerClassName, { isOpen })}>
          <span />
          <span />
          <span />
        </div>
        <div onClick={this.close} className={cx('backdrop', { isOpen })} />
        <div className={cx('popout', contentClassName, { isOpen })}>
          {children}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/PopoutActionsMenu.js